import React from 'react'
import {Icon} from '@chakra-ui/react'

const FavouriteFilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="currentColor" {...props}>
            <path d="M9.96387 2.03125C10.8341 1.81952 11.7486 1.87773 12.585 2.19824C13.4214 2.51888 14.1407 3.08686 14.6465 3.82617C15.1516 4.56458 15.4196 5.4394 15.416 6.33398L15.4023 6.67773C15.2635 8.36757 14.1239 9.60263 13.1963 10.5303L13.1875 10.5391L9.52637 14.0811L9.52539 14.0801C9.33939 14.2808 9.11726 14.4462 8.86816 14.5605C8.59981 14.6836 8.30792 14.7481 8.0127 14.75C7.71726 14.7518 7.42434 14.6911 7.1543 14.5713C6.90055 14.4586 6.67337 14.2947 6.4834 14.0928V14.0938L2.81152 10.5391L2.80273 10.5303C1.81399 9.54152 0.583291 8.20865 0.583008 6.33398C0.583024 5.44053 0.854177 4.56729 1.36035 3.83105C1.86658 3.09491 2.58476 2.52981 3.41895 2.20996C4.2533 1.89017 5.16548 1.83083 6.03418 2.04004C6.77065 2.21748 7.44535 2.58227 7.99805 3.09375C8.54976 2.5787 9.22612 2.2109 9.96387 2.03125Z" />
        </Icon>
    )
}

export default FavouriteFilledIcon
